const REGISTRATION_KEY = 'freeShippingMessageRegistered';

/**
 * Formats a value in Shopify's smallest currency unit using the shop money format.
 * @param {number} value
 * @param {string} template
 * @returns {string}
 */
function formatMoney(value, template) {
  return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
    if (placeholder === 'currency') return '';

    let thousands = ',';
    let decimal = '.';
    let precision = 2;

    if (placeholder.includes('no_decimals')) precision = 0;
    if (placeholder.includes('comma_separator')) {
      thousands = '.';
      decimal = ',';
    } else if (placeholder.includes('space_separator')) {
      thousands = ' ';
      decimal = placeholder.includes('period_and_space') ? '.' : ',';
    } else if (placeholder.includes('apostrophe_separator')) {
      thousands = "'";
    }

    const parts = (Math.max(0, value) / 100).toFixed(precision).split('.');
    const integer = (parts[0] || '0').replace(/\d(?=(\d{3})+(?!\d))/g, `$&${thousands}`);
    return precision === 0 ? integer : `${integer}${decimal}${parts[1]}`;
  });
}

/** @param {number} totalPrice */
function updateFreeShippingMessage(totalPrice) {
  document.querySelectorAll('[data-free-shipping-message]').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;

    const threshold = Number(element.dataset.threshold) || 1000000;
    const remaining = Math.max(0, threshold - Number(totalPrice || 0));
    const moneyFormatTemplate = element.querySelector('[data-money-format]');
    const moneyFormat = moneyFormatTemplate?.content?.textContent || '{{amount}}';
    const highlight = document.createElement('span');
    highlight.className = 'free-shipping-message__highlight';
    highlight.textContent = '送料無料';

    element.replaceChildren(
      ...(moneyFormatTemplate ? [moneyFormatTemplate] : []),
      remaining === 0
        ? document.createTextNode('カート内の商品は')
        : document.createTextNode(`あと${formatMoney(remaining, moneyFormat)}のご購入で`),
      highlight,
      document.createTextNode('です。')
    );
  });
}

if (!window[REGISTRATION_KEY]) {
  window[REGISTRATION_KEY] = true;
  let requestId = 0;

  const refreshFromCart = async () => {
    const currentRequest = ++requestId;
    try {
      const cartUrl = document.querySelector('[data-free-shipping-message]')?.dataset?.cartUrl || '/cart.js';
      const response = await fetch(cartUrl);
      const cart = await response.json();
      if (currentRequest === requestId) updateFreeShippingMessage(cart.total_price);
    } catch (error) {
      console.error('Unable to update free shipping message', error);
    }
  };

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.cart;
    if (typeof cart?.total_price === 'number') updateFreeShippingMessage(cart.total_price);
  });

  document.addEventListener('cart:update', (event) => {
    const cart = event.detail?.resource;
    if (typeof cart?.total_price === 'number') {
      updateFreeShippingMessage(cart.total_price);
    } else {
      refreshFromCart();
    }
  });

  document.addEventListener('discount:update', (event) => {
    const cart = event.detail?.resource;
    if (typeof cart?.total_price === 'number') updateFreeShippingMessage(cart.total_price);
    else refreshFromCart();
  });
}
